import useOrganization from '../../hooks/use-organization';
import OrganizationDashboard from './organizationView';
import Welcome from './welcome';

function DashboardIndex() {
  const organizationInfo = useOrganization();

  return organizationInfo?.id ? <OrganizationDashboard /> : <Welcome />;
}

export default DashboardIndex;
